import { WidgetLinkType } from 'data/Show'
import { faGlobe, IconDefinition } from '@fortawesome/free-solid-svg-icons'
import {
    faFacebookF,
    faInstagram,
    faSpotify,
    faTwitter,
    faYoutube,
    faLinkedin,
} from '@fortawesome/free-brands-svg-icons'

const socialIcons: { [k in WidgetLinkType]: IconDefinition } = {
    [WidgetLinkType.FACEBOOK]: faFacebookF,
    [WidgetLinkType.TWITTER]: faTwitter,
    [WidgetLinkType.INSTAGRAM]: faInstagram,
    [WidgetLinkType.YOUTUBE]: faYoutube,
    [WidgetLinkType.SPOTIFY]: faSpotify,
    [WidgetLinkType.WEBSITE]: faGlobe,
    [WidgetLinkType.LINKEDIN]: faLinkedin,
}

export default socialIcons
